<h2 mat-dialog-title class="dialog-header">{{'locker.discount.details.title'|traduccion}} {{data?.discount?.id}}
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="dialog-content mat-typography">

    <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-4">

        <div appGridColumns [colsLg]="2" [colsMd]="1" [colsSm]="1" [colWidths]="[50, 50]">
            <mat-card>
                <h3>{{'locker.discount.details.form.info'|traduccion}}</h3>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.id.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="code"/>
                    <mat-hint>{{'locker.discount.details.form.code.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('code')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.description.label'|traduccion}}</mat-label>
                    <input matInput type="text" formControlName="description" />
                    <mat-hint>{{'locker.discount.details.form.description.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('description')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.discountType.label'|traduccion}}</mat-label>
                    <mat-select formControlName="discountType">
                        <mat-option value="PERCENTAGE">PERCENTAGE</mat-option>
                        <mat-option value="AMOUNT">AMOUNT</mat-option>
                    </mat-select>
                    <mat-hint>{{'locker.discount.details.form.discountType.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('discountType')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.discount.label'|traduccion}}</mat-label>
                    <input matInput type="number" formControlName="discount" />
                    <mat-icon *ngIf="form.get('discountType').value=='PERCENTAGE'" matSuffix>percent</mat-icon>
                    <mat-icon *ngIf="form.get('discountType').value=='AMOUNT'" matSuffix>euro_symbol</mat-icon>
                    <mat-hint>{{'locker.discount.details.form.discount.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('discount')" ></app-form-error>
                </mat-form-field>

                <!-- Related group -->
                <div class="col-span-2 related-group">
                    <h4 class="section-title">{{'locker.discount.details.form.related.label'|traduccion}}</h4>
                    <mat-form-field appearance="outline">
                        <mat-label>{{'locker.discount.details.form.relatedData.label'|traduccion}}</mat-label>
                        <input matInput formControlName="relatedData" />
                        <mat-hint>{{'locker.discount.details.form.related.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('related')" ></app-form-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>{{'locker.discount.details.form.relatedDataType.label'|traduccion}}</mat-label>
                        <input matInput formControlName="relatedDataType" />
                        <mat-hint>{{'locker.discount.details.form.relatedDataType.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('relatedDataType')" ></app-form-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>{{'locker.discount.details.form.relatedType.label'|traduccion}}</mat-label>
                        <mat-select formControlName="relatedType">
                            <mat-option [value]="null">Seleccionar</mat-option>
                            <mat-option value="PROMO_KEY">PROMO_KEY</mat-option>
                            <mat-option value="COMMISSION_AGENT">COMMISSION_AGENT</mat-option>
                        </mat-select>
                        <mat-hint>{{'locker.discount.details.form.relatedType.hint'|traduccion}}</mat-hint>
                        <app-form-error [control]="form.get('relatedType')" ></app-form-error>
                    </mat-form-field>


                    <div class="flex items-center col-span-2">
                        <mat-checkbox formControlName="enabled">{{'locker.discount.details.form.enabled.label'|traduccion}}</mat-checkbox>
                    </div>
                </div>

            </mat-card>

            <mat-card>
                <h3>{{'locker.discount.details.form.filter'|traduccion}}</h3>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.productIds.label'|traduccion}}</mat-label>
                    <mat-select formControlName="productIds" multiple>
                        <mat-option *ngFor="let product of products" [value]="product.id">
                            {{ productLabel(product) }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>{{'locker.discount.details.form.productIds.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('productIds')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.priceIds.label'|traduccion}}</mat-label>
                    <mat-select formControlName="priceIds" multiple>
                        <mat-optgroup *ngFor="let product of selectedProducts; trackBy: trackByProductId" [label]="productLabel(product)">
                            <mat-option *ngFor="let price of product.prices; trackBy: trackByPriceId" [value]="price.id">
                                {{ priceLabel(price) }}
                            </mat-option>
                        </mat-optgroup>
                    </mat-select>
                    <mat-hint>{{'locker.discount.details.form.priceIds.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('priceIds')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.earlyPeriod.label'|traduccion}}</mat-label>
                    <input matInput type="number" formControlName="earlyPeriod" />
                    <mat-hint>{{'locker.discount.details.form.earlyPeriod.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('earlyPeriod')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.offsetPeriod.label'|traduccion}}</mat-label>
                    <input matInput type="number" formControlName="offsetPeriod" />
                    <mat-hint>{{'locker.discount.details.form.offsetPeriod.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('offsetPeriod')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.periodUnit.label'|traduccion}}</mat-label>
                    <mat-select formControlName="periodUnit">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor="let unit of periodUnitOptions" [value]="unit">
                            {{ unit }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>{{'locker.discount.details.form.periodUnit.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('periodUnit')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.offsetProduct.label'|traduccion}}</mat-label>
                    <input matInput type="number" formControlName="offsetProduct" />
                    <mat-hint>{{'locker.discount.details.form.offsetProduct.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('offsetProduct')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.maxUse.label'|traduccion}}</mat-label>
                    <input matInput type="number" formControlName="maxUse" />
                    <mat-hint>{{'locker.discount.details.form.maxUse.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('maxUse')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.timesUsed.label'|traduccion}}</mat-label>
                    <input matInput type="number" formControlName="timesUsed" />
                    <mat-hint>{{'locker.discount.details.form.timesUsed.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('timesUsed')" ></app-form-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'locker.discount.details.form.expirationDate.label'|traduccion}}</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="expirationDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-hint>{{'locker.discount.details.form.expirationDate.hint'|traduccion}}</mat-hint>
                    <app-form-error [control]="form.get('hint')" ></app-form-error>
                </mat-form-field>

            </mat-card>


        </div>




    </form>


</mat-dialog-content>


<mat-dialog-actions align="end" class="dialog-footer">
    <span class="spacer"></span>
    <button mat-flat-button color="primary" [disabled]="!form.valid"
        (click)="confirm()">{{'locker.discount.details.action.save'|traduccion}}</button>
    <button *ngIf="!isNew" mat-stroked-button color="warn"
        (click)="deleteDiscount()">{{'locker.discount.details.action.delete'|traduccion}}</button>
</mat-dialog-actions>
